//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BlueResultsItem",
  props: ["result", "formatDate", "openInNewWindow"],
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
    },
    metaData() {
        return `${this.result.meta.search_metadata1} | ${this.result.meta.search_metadata2} | ${this.result.meta.search_metadata3} | ${this.result.meta.search_metadata4} | ${String(this.result.meta.search_metadata5)}`
    },
    metaDataArray() {
      var value = [];

      if (this.result.meta.search_metadata1){
        value.push(this.result.meta.search_metadata1)
      }
      if (this.result.meta.search_metadata2){
        value.push(this.result.meta.search_metadata2)
      }
      if (this.result.meta.search_metadata3){
        value.push(this.result.meta.search_metadata3)
      }
      if (this.result.meta.search_metadata4){
        value.push(this.result.meta.search_metadata4)
      }
      if (this.result.meta.search_metadata5){
        value.push(this.result.meta.search_metadata5)
      }
      return value.join(" | ");
    }

  }
};
